import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Scissors } from "lucide-react";
import { Link } from "react-router-dom";
import { subscribeTopInset } from "@/utils/telegram";

const scrollTo = (target) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -20, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const Header = () => {
  const [topInset, setTopInset] = useState(0);
  useEffect(() => subscribeTopInset(setTopInset), []);

  return (
  <motion.header
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 top-0 z-40 border-b border-white/5 bg-[#0A0A0A]/60 backdrop-blur-xl"
    style={{ top: topInset }}
    data-testid="site-header"
  >
    <div className="flex items-center justify-between px-6 py-4 md:px-12">
      <button
        onClick={() => scrollTo("#top")}
        className="flex items-center gap-3"
        data-testid="header-logo"
      >
        <Scissors size={15} strokeWidth={1.5} className="text-[#C2A878]" />
        <span className="font-jetbrains text-sm tracking-[0.35em] text-[#F4F4F0]">AFANASIEV</span>
      </button>

      <nav className="hidden items-center gap-10 md:flex" data-testid="header-nav">
        <button
          onClick={() => scrollTo("#manifesto")}
          className="font-jetbrains text-xs uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors duration-500 hover:text-[#F4F4F0]"
          data-testid="nav-manifesto-link"
        >
          Манифест
        </button>
        <button
          onClick={() => scrollTo("#benefits")}
          className="font-jetbrains text-xs uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors duration-500 hover:text-[#F4F4F0]"
          data-testid="nav-benefits-link"
        >
          Преимущества
        </button>
        <button
          onClick={() => scrollTo("#pricing")}
          className="font-jetbrains text-xs uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors duration-500 hover:text-[#F4F4F0]"
          data-testid="nav-pricing-link"
        >
          Тарифы
        </button>
        <Link
          to="/account"
          className="font-jetbrains text-xs uppercase tracking-[0.2em] text-[#A3A3A3] transition-colors duration-500 hover:text-[#F4F4F0]"
          data-testid="nav-account-link"
        >
          Кабинет
        </Link>
        <Link
          to="/preview"
          className="border border-[#C2A878] px-5 py-2.5 font-jetbrains text-xs uppercase tracking-[0.2em] text-[#C2A878] transition-colors duration-500 hover:bg-[#C2A878] hover:text-[#0A0A0A]"
          data-testid="nav-test-app-button"
        >
          Открыть приложение
        </Link>
        <button
          onClick={() => scrollTo("#preorder")}
          className="border border-[#C2A878] px-6 py-2.5 font-jetbrains text-xs uppercase tracking-[0.2em] text-[#C2A878] transition-colors duration-500 hover:bg-[#C2A878] hover:text-[#0A0A0A]"
          data-testid="nav-preorder-button"
        >
          Получить доступ
        </button>
      </nav>

      <div className="flex items-center gap-2 md:hidden">
        <Link
          to="/preview"
          className="whitespace-nowrap border border-[#C2A878] px-4 py-2 font-jetbrains text-[9px] uppercase tracking-[0.15em] text-[#C2A878]"
          data-testid="nav-test-app-button-mobile"
        >
          Открыть приложение
        </Link>
      </div>
    </div>
  </motion.header>
  );
};
